import './lib/iframe-error-reporter';
import App from './app/app';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { DEFAULT_LOCALE, I18nProvider, tryParseLocale, type Locale } from './i18n';
import { AppErrorBoundary } from './components/monitoring/app-error-boundary';
import { initPostHog } from './lib/posthog';

function readBootstrapLocale(): Locale {
  const bootstrapValue = typeof window !== 'undefined' ? window.__INITIAL_LOCALE__ : undefined;
  return tryParseLocale(bootstrapValue) ?? DEFAULT_LOCALE;
}

const CMS_BOOTSTRAP_LOADER_ID = 'cms-bootstrap-loader';

const dismissBootstrapLoader = () => {
  const loader = document.getElementById(CMS_BOOTSTRAP_LOADER_ID);
  if (!loader) {
    return;
  }

  loader.setAttribute('data-state', 'exit');
  window.setTimeout(() => {
    loader.remove();
  }, 220);
};

const rootElement = document.getElementById('root');
if (rootElement) {
  initPostHog();
  const locale = readBootstrapLocale();
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <AppErrorBoundary>
        <BrowserRouter>
          <I18nProvider initialLocale={locale}>
            <App />
          </I18nProvider>
        </BrowserRouter>
      </AppErrorBoundary>
    </React.StrictMode>
  );

  window.requestAnimationFrame(() => {
    dismissBootstrapLoader();
  });
}

if (typeof module !== 'undefined' && module?.hot) {
  module.hot.accept();
}
